export const Color = {
  nivo: {
    indigo: '#201841',
    green: '#5fbfba',
    blue: '#3a2870',
    red: '#ea5050',
    orange: '#ee7134',
    black: '#363636',
    grey: '#ededed',
    pink: '#faf2f2',
    notification: '#a9a9a9',
  },
  goDark: '#b1a194',
  darkGrey: '#4a4a4a',
  grey: '#7a7a7a',
  greenAlt: '#50e3c2',
  white: '#fff',
  backgroundGrey: '#f2f2f2',
  linkBlue: '#007aff',
  blackTer: '#242424',
};

export const Font = {
  fontFamily: 'Raleway, "Helvetica Neue", Roboto, Helvetica, Arial, sans-serif',
};
